// See more error codes at https://next-auth.js.org/configuration/pages
export const OAUTH_SIGNIN_ERROR = "OAuthSignin";
export const OAUTH_ACCOUNT_NOT_LINKED_ERROR = "OAuthAccountNotLinked";
export const EMAIL_SIGNIN_ERROR = "EmailSignin";

export const getHumanErrorMessage = (error: string) => {
  if (error === OAUTH_SIGNIN_ERROR) {
    return "Ocorreu um erro ao entrar com o provedor selecionado. Tente novamente.";
  }

  if (error === OAUTH_ACCOUNT_NOT_LINKED_ERROR) {
    return "Esta conta já existe com login por e-mail. Entre usando o magic link e, depois, acesse Configurações → Segurança para conectar sua conta Google.";
  }

  if (error === EMAIL_SIGNIN_ERROR) {
    return "Não foi possível enviar o e-mail. Tente novamente.";
  }

  return "Ocorreu um erro. Tente novamente.";
};
